import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.kiera.rack.editor');
import { EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';


const rackEditorApi = new Wiz('/wiz').app('page.kiera.zones');


@Component({
 standalone: false,
 selector: 'wiz-component-kiera-rack-editor',
template: templateSource || '',
    styles: [`

/* file: /opt/app/project/main/.kiera-build/src/app/component.kiera.rack.editor/view.scss */
:host {
  display: contents;
}

button:disabled {
  cursor: not-allowed;
}

.rack-remove-drop-indicator {
  position: fixed;
  top: 22px;
  left: 50%;
  z-index: 95;
  display: flex;
  align-items: center;
  gap: 7px;
  transform: translateX(-50%);
  border: 1px dashed #fb7185;
  border-radius: 999px;
  background: rgba(255, 241, 242, 0.96);
  padding: 9px 15px;
  color: #be123c;
  font-size: 10px;
  font-weight: 700;
  pointer-events: none;
  box-shadow: 0 10px 24px rgba(190, 18, 60, 0.2);
}

.rack-remove-drop-indicator i {
  font-size: 16px;
}

.rack-create-scroll {
  scrollbar-gutter: stable;
}

.rack-placement-filter-select {
  box-sizing: border-box;
  display: block;
  height: 32px;
  padding: 0 24px 0 8px !important;
  font-size: 10px;
  line-height: 30px !important;
  vertical-align: middle;
}

.rack-placement-filter-select option {
  font-size: 11px;
  line-height: normal;
}

.rack-create-frame {
  box-sizing: content-box;
  min-height: 16px;
  box-shadow: inset 0 0 0 3px #f8fafc;
}

.rack-create-unit {
  position: relative;
  height: 16px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
  transition: background-color 100ms ease;
}

.rack-create-unit:hover {
  background: #eff6ff;
}

.rack-create-unit > span {
  position: absolute;
  top: 1px;
  left: 7px;
  color: #94a3b8;
  font-size: 8px;
  font-weight: 600;
  line-height: 13px;
}

.rack-create-mounted-node {
  display: flex;
  min-height: 15px;
  flex-direction: column;
  justify-content: center;
  line-height: 10px;
}

.rack-create-mounted-node-dragging {
  opacity: 0.3;
  box-shadow: 0 8px 18px rgba(15, 23, 42, 0.2);
}

.rack-create-drag-shadow {
  position: absolute;
  right: 8px;
  left: 40px;
  z-index: 20;
  display: flex;
  min-height: 15px;
  align-items: center;
  gap: 5px;
  overflow: hidden;
  border: 1px dashed currentColor;
  border-radius: 4px;
  padding: 0 8px;
  font-size: 9px;
  font-weight: 700;
  line-height: 14px;
  opacity: 0.88;
  pointer-events: none;
  box-shadow: 0 8px 20px rgba(37, 99, 235, 0.24), inset 0 0 0 1px rgba(255, 255, 255, 0.75);
  animation: rack-drag-shadow-pulse 650ms ease-in-out infinite alternate;
}

.rack-create-drag-shadow-node {
  background: rgba(219, 234, 254, 0.9);
  color: #1d4ed8;
}

.rack-create-drag-shadow-chassis {
  background: rgba(209, 250, 229, 0.94);
  color: #047857;
  box-shadow: 0 8px 20px rgba(5, 150, 105, 0.22), inset 0 0 0 1px rgba(255, 255, 255, 0.82);
}

.rack-create-drag-shadow-device {
  background: rgba(237, 233, 254, 0.92);
  color: #7c3aed;
  box-shadow: 0 8px 20px rgba(124, 58, 237, 0.24), inset 0 0 0 1px rgba(255, 255, 255, 0.78);
}

@keyframes rack-drag-shadow-pulse {
  from {
    filter: brightness(0.98);
    transform: scale(0.995);
  }
  to {
    filter: brightness(1.04);
    transform: scale(1);
  }
}`],
})
export class ComponentKieraRackEditorComponent implements OnInit {
    @Input() rack: any = null;
    @Input() zones: any[] = [];
    @Output() saved = new EventEmitter<any>();
    @Output() closed = new EventEmitter<void>();

    public loading: boolean = true;
    public rackCreating: boolean = false;
    public rackCloseConfirming: boolean = false;
    public rackWizardStep: number = 1;
    public rackWizardError: string = '';
    public rackNodeLoading: boolean = false;
    public rackNodeSourceTab: string = 'nodes';
    public rackNodeSearchText: string = '';
    public rackIncludedNodeSearchText: string = '';
    public rackNodePage: number = 1;
    public rackNodePageSize: number = 10;
    public rackIncludedNodePage: number = 1;
    public rackIncludedNodePageSize: number = 10;
    public rackNodeSortDirection: string = 'asc';
    public rackIncludedNodeSortDirection: string = 'asc';
    public rackAutoNodeUnitSize: number = 1;
    public rackAutoPlacementPolicy: string = 'top';
    public rackPlacementSearchText: string = '';
    public rackPlacementTypeFilter: string = 'all';
    public rackPlacementUnitFilter: string = 'all';
    public rackPlacementStatusFilter: string = 'all';
    public rackPlacementSummarySort: string = 'unit-desc';
    public rackPlacementFiltersOpen: boolean = false;
    public rackCandidates: any[] = [];
    public rackChassisCandidates: any[] = [];
    public rackIncludedNodeIds: number[] = [];
    public rackIncludedChassisIds: number[] = [];
    public rackIncludedDevices: any[] = [];
    public rackAvailableNodeSelection: number[] = [];
    public rackAvailableChassisSelection: number[] = [];
    public rackIncludedNodeSelection: number[] = [];
    public rackIncludedChassisSelection: number[] = [];
    public rackPlacements: any[] = [];
    public draggedRackNodeId: number = 0;
    public draggedRackPlacementKey: string = '';
    public rackDragShadow: any = null;
    public rackDraggedFromPreview: boolean = false;
    public rackRemoveDropActive: boolean = false;
    public rackEditingId: number = 0;
    public rackDeviceSequence: number = 0;
    public rackForm: any = {
        zone_id: 0,
        rack: 0,
        name: '',
        description: '',
        capacity_u: 42,
        active: true,
    };
    public rackDeviceDraft: any = this.emptyRackDeviceDraft();
    private rackInitialFormState: string = '';
    private rackInitialIncludedNodeState: string = '';
    private rackInitialIncludedChassisState: string = '';
    private rackInitialIncludedDeviceState: string = '';
    private rackInitialPlacementsState: string = '';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadRackEditor();
    }

    private async loadRackEditor() {
        this.rackEditingId = Number(this.rack?.rack_record_id || this.rack?.id || 0);
        if (this.rackEditingId <= 0) {
            this.loading = false;
            this.rackWizardError = '수정할 Rack을 찾을 수 없습니다.';
            await this.service.render();
            return;
        }

        this.loading = true;
        this.rackNodeLoading = true;
        this.rackWizardError = '';
        await this.service.render();
        try {
            const { code, data } = await rackEditorApi.call('rack_nodes', {
                rack_id: this.rackEditingId,
            });
            if (code !== 200) {
                this.rackWizardError = data?.message || 'Rack 편집 정보를 불러오지 못했습니다.';
                return;
            }

            const record = data?.rack || {};
            const rackCode = record?.rack ?? this.rack?.rack ?? this.rack?.rack_id;
            this.rackForm = {
                zone_id: Number(this.rack?.zone_id || 0),
                rack: Number(rackCode || 0),
                name: String(record?.name || this.rack?.rack_name || this.rack?.name || ''),
                description: String(record?.description || this.rack?.description || ''),
                capacity_u: Number(
                    record?.capacity_u
                    || this.rack?.rack_size_u
                    || this.rack?.capacity_u
                    || 42
                ),
                active: this.isActive(record?.active ?? this.rack?.active),
            };
            this.rackCandidates = Array.isArray(data?.nodes) ? data.nodes : [];
            this.rackChassisCandidates = Array.isArray(data?.chassis) ? data.chassis : [];
            const includedResources = Array.isArray(data?.placements)
                ? data.placements.map((placement: any) => ({ ...placement }))
                : [];
            this.rackPlacements = includedResources.filter(
                (placement: any) => Number(placement?.unit_order || 0) > 0,
            );
            this.initializeRackIncludedNodes(includedResources);
            this.captureRackInitialState();
        } catch (error) {
            this.rackWizardError = String(error || 'Rack 편집 정보를 불러오지 못했습니다.');
        } finally {
            this.loading = false;
            this.rackNodeLoading = false;
            await this.service.render();
        }
    }

    public emptyRackDeviceDraft(): any {
        return {
            name: '',
            device_type: 'switch',
            unit_size: 1,
        };
    }

    private isActive(value: any): boolean {
        return value !== false && value !== 0 && value !== '0';
    }

    public zoneLocation(zone: any): string {
        return String(zone?.location || '').trim() || '위치 미지정';
    }

    private rackFormState(): string {
        return JSON.stringify({
            zone_id: Number(this.rackForm?.zone_id || 0),
            rack: Number(this.rackForm?.rack || 0),
            name: String(this.rackForm?.name || ''),
            description: String(this.rackForm?.description || ''),
            capacity_u: Number(this.rackForm?.capacity_u || 0),
            active: Boolean(this.rackForm?.active),
        });
    }

    private rackPlacementsState(): string {
        const placements = (this.rackPlacements || []).map((placement: any) => ({
            key: this.rackPlacementIdentity(placement),
            placement_type: ['device', 'chassis'].includes(placement?.placement_type)
                ? placement.placement_type
                : 'node',
            node_id: Number(placement?.node_id || 0),
            chassis_id: Number(placement?.chassis_id || 0),
            device_id: Number(placement?.device_id || 0),
            client_key: String(placement?.client_key || ''),
            name: placement?.placement_type === 'device' ? String(placement?.name || '') : '',
            device_type: placement?.placement_type === 'device'
                ? String(placement?.device_type || 'switch')
                : '',
            notes: placement?.placement_type === 'device' ? String(placement?.notes || '') : '',
            unit_order: Number(placement?.unit_order || 0),
            unit_size: Number(placement?.unit_size || 0),
        })).sort((left: any, right: any) => left.key.localeCompare(right.key));
        return JSON.stringify(placements);
    }

    private rackIncludedNodesState(): string {
        return JSON.stringify(
            this.rackIncludedNodeIds
                .map((nodeId: number) => Number(nodeId))
                .filter((nodeId: number) => nodeId > 0)
                .sort((left: number, right: number) => left - right)
        );
    }

    private rackIncludedChassisState(): string {
        return JSON.stringify(
            this.rackIncludedChassisIds
                .map((chassisId: number) => Number(chassisId))
                .filter((chassisId: number) => chassisId > 0)
                .sort((left: number, right: number) => left - right),
        );
    }

    private rackIncludedDevicesState(): string {
        return JSON.stringify(
            this.rackIncludedDevices
                .map((device: any) => ({
                    key: this.rackPlacementIdentity(device),
                    name: String(device?.name || ''),
                    device_type: String(device?.device_type || 'switch'),
                    notes: String(device?.notes || ''),
                    unit_size: Number(device?.unit_size || 1),
                }))
                .sort((left: any, right: any) => left.key.localeCompare(right.key)),
        );
    }

    private captureRackInitialState() {
        this.rackInitialFormState = this.rackFormState();
        this.rackInitialIncludedNodeState = this.rackIncludedNodesState();
        this.rackInitialIncludedChassisState = this.rackIncludedChassisState();
        this.rackInitialIncludedDeviceState = this.rackIncludedDevicesState();
        this.rackInitialPlacementsState = this.rackPlacementsState();
    }

    public get rackWizardHasUnsavedChanges(): boolean {
        if (!this.rackInitialFormState) return false;
        return (
            this.rackFormState() !== this.rackInitialFormState
            || this.rackIncludedNodesState() !== this.rackInitialIncludedNodeState
            || this.rackIncludedChassisState() !== this.rackInitialIncludedChassisState
            || this.rackIncludedDevicesState() !== this.rackInitialIncludedDeviceState
            || this.rackPlacementsState() !== this.rackInitialPlacementsState
        );
    }

    private get rackAvailableNodes(): any[] {
        const includedIds = new Set(this.rackIncludedNodeIds.map(Number));
        return this.rackCandidates.filter((node: any) => {
            const nodeId = Number(node?.id || 0);
            return (
                !includedIds.has(nodeId)
                && Number(node?.chassis_id || 0) <= 0
            );
        });
    }

    private get rackAvailableChassis(): any[] {
        const includedIds = new Set(this.rackIncludedChassisIds.map(Number));
        return this.rackChassisCandidates.filter((chassis: any) => {
            const chassisId = Number(chassis?.id || 0);
            const rackId = Number(chassis?.rack_record_id || 0);
            return (
                !includedIds.has(chassisId)
                && (rackId <= 0 || rackId === this.rackEditingId)
            );
        });
    }

    private normalizeRackPageSize(value: any): number {
        const pageSize = Math.floor(Number(value));
        return Number.isFinite(pageSize) && pageSize > 0
            ? Math.min(100, pageSize)
            : 10;
    }

    private compareRackResourceNames(left: any, right: any, direction: string): number {
        const result = String(left?.name || '').localeCompare(
            String(right?.name || ''),
            undefined,
            { numeric: true, sensitivity: 'base' },
        );
        if (result !== 0) return direction === 'desc' ? -result : result;
        const idResult = Number(
            left?.id || left?.node_id || left?.chassis_id || 0,
        ) - Number(
            right?.id || right?.node_id || right?.chassis_id || 0,
        );
        return direction === 'desc' ? -idResult : idResult;
    }

    private compareRackNodeNames(left: any, right: any, direction: string): number {
        return this.compareRackResourceNames(left, right, direction);
    }

    private sortRackNodes(nodes: any[], direction: string): any[] {
        return nodes.slice().sort(
            (left: any, right: any) => this.compareRackResourceNames(left, right, direction),
        );
    }

    public get filteredRackCandidates(): any[] {
        const term = this.rackNodeSearchText.trim().toLowerCase();
        const candidates = this.rackAvailableNodes.filter((node: any) => {
            if (!term) return true;
            return [
                node.name,
                node.bmc_ip,
                node.group_name,
                node.rack_name,
                node.rack,
            ]
                .some((value: any) => String(value || '').toLowerCase().includes(term));
        });
        return this.sortRackNodes(candidates, this.rackNodeSortDirection);
    }

    public get filteredRackChassisCandidates(): any[] {
        const term = this.rackNodeSearchText.trim().toLowerCase();
        const candidates = this.rackAvailableChassis.filter((chassis: any) => {
            if (!term) return true;
            return [
                chassis?.name,
                chassis?.model,
                chassis?.serial,
                ...(chassis?.nodes || []).map((node: any) => node?.name),
            ].some((value: any) => String(value || '').toLowerCase().includes(term));
        });
        return this.sortRackNodes(candidates, this.rackNodeSortDirection);
    }

    public get pagedRackCandidates(): any[] {
        if (this.rackNodeSourceTab !== 'nodes') return [];
        const pageSize = this.normalizeRackPageSize(this.rackNodePageSize);
        const start = (this.rackNodePage - 1) * pageSize;
        return this.filteredRackCandidates.slice(start, start + pageSize);
    }

    public get pagedRackChassisCandidates(): any[] {
        if (this.rackNodeSourceTab !== 'chassis') return [];
        const pageSize = this.normalizeRackPageSize(this.rackNodePageSize);
        const start = (this.rackNodePage - 1) * pageSize;
        return this.filteredRackChassisCandidates.slice(start, start + pageSize);
    }

    public get rackAvailableSourceCount(): number {
        if (this.rackNodeSourceTab === 'chassis') {
            return this.filteredRackChassisCandidates.length;
        }
        if (this.rackNodeSourceTab === 'network') return 0;
        return this.filteredRackCandidates.length;
    }

    public get rackNodeSourceTitle(): string {
        if (this.rackNodeSourceTab === 'chassis') return '미배치 Chassis 목록';
        if (this.rackNodeSourceTab === 'network') return '네트워크 장비';
        return '독립 Node 목록';
    }

    public get rackNodeSourceDescription(): string {
        if (this.rackNodeSourceTab === 'chassis') {
            return 'Rack에 미배치된 Chassis를 선택하세요.';
        }
        if (this.rackNodeSourceTab === 'network') {
            return '네트워크 장비는 3단계에서 직접 추가하고 배치합니다.';
        }
        return 'Chassis에 포함되지 않은 Node를 표시합니다. 기존 Rack Node는 저장 시 이 Rack으로 이동합니다.';
    }

    public get rackNodeSearchPlaceholder(): string {
        if (this.rackNodeSourceTab === 'chassis') {
            return 'Chassis 이름, 모델, Serial 검색...';
        }
        return 'Node 이름, BMC IP, 그룹, 현재 Rack 검색...';
    }

    private rackActiveAvailableNodeIds(): number[] {
        return this.rackNodeSourceTab === 'nodes'
            ? this.pagedRackCandidates
                .map((node: any) => Number(node?.id || 0))
                .filter((nodeId: number) => nodeId > 0)
            : [];
    }

    private rackActiveAvailableChassisIds(): number[] {
        return this.rackNodeSourceTab === 'chassis'
            ? this.pagedRackChassisCandidates
                .map((chassis: any) => Number(chassis?.id || 0))
                .filter((chassisId: number) => chassisId > 0)
            : [];
    }

    public get rackIncludedNodes(): any[] {
        return this.rackIncludedNodeIds
            .map((nodeId: number) => {
                const candidate = this.rackNode(nodeId);
                if (candidate) return candidate;
                const placement = this.rackPlacements.find((item: any) => (
                    item?.placement_type === 'node'
                    && Number(item?.node_id || 0) === Number(nodeId)
                ));
                return placement ? { ...placement, id: Number(nodeId) } : null;
            })
            .filter((node: any) => Boolean(node));
    }

    public get rackIncludedChassis(): any[] {
        return this.rackIncludedChassisIds
            .map((chassisId: number) => {
                const candidate = this.rackChassisCandidates.find(
                    (chassis: any) => Number(chassis?.id || 0) === Number(chassisId),
                );
                if (candidate) {
                    return {
                        ...candidate,
                        placement_type: 'chassis',
                        chassis_id: Number(candidate?.id || chassisId),
                    };
                }
                const placement = this.rackPlacements.find((item: any) => (
                    item?.placement_type === 'chassis'
                    && Number(item?.chassis_id || 0) === Number(chassisId)
                ));
                return placement ? { ...placement, id: Number(chassisId) } : null;
            })
            .filter((chassis: any) => Boolean(chassis));
    }

    public get sortedRackIncludedChassis(): any[] {
        return this.sortRackNodes(
            this.rackIncludedChassis,
            this.rackIncludedNodeSortDirection,
        );
    }

    public get rackAvailableSelectionCount(): number {
        return this.rackNodeSourceTab === 'chassis'
            ? this.rackAvailableChassisSelection.length
            : this.rackAvailableNodeSelection.length;
    }

    public get rackIncludedSelectionCount(): number {
        return (
            this.rackIncludedNodeSelection.length
            + this.rackIncludedChassisSelection.length
        );
    }

    public get rackIncludedResourceCount(): number {
        return (
            this.rackIncludedNodeIds.length
            + this.rackIncludedChassisIds.length
            + this.rackIncludedDevices.length
        );
    }

    public get rackIncludedChassisNodeCount(): number {
        return this.rackIncludedChassis.reduce(
            (total: number, chassis: any) => total + Number(chassis?.node_count || 0),
            0,
        );
    }

    public get rackIncludedNetworkCount(): number {
        return this.rackIncludedDevices.length;
    }

    public get rackIncludedMovingNodeCount(): number {
        return this.rackIncludedNodes.filter(
            (node: any) => this.rackNodeWillMove(node),
        ).length;
    }

    public get rackIncludedNetworkUnits(): number {
        return this.rackIncludedDevices.reduce(
            (total: number, placement: any) => (
                total + Math.max(1, Number(placement?.unit_size || 1))
            ),
            0,
        );
    }

    public get rackIncludedResourceUnits(): number {
        const nodeUnits = this.rackIncludedNodes.reduce(
            (total: number, node: any) => total + Math.max(1, Number(node?.unit_size || 1)),
            0,
        );
        const chassisUnits = this.rackIncludedChassis.reduce(
            (total: number, chassis: any) => total + Math.max(1, Number(chassis?.unit_size || 1)),
            0,
        );
        const networkUnits = this.rackIncludedNetworkUnits;
        return nodeUnits + chassisUnits + networkUnits;
    }

    public get filteredRackIncludedNodes(): any[] {
        const term = this.rackIncludedNodeSearchText.trim().toLowerCase();
        if (!term) return this.sortedRackIncludedNodes;
        return this.sortedRackIncludedNodes.filter((node: any) => [node.name, node.bmc_ip]
            .some((value: any) => String(value || '').toLowerCase().includes(term)));
    }

    public get sortedRackIncludedNodes(): any[] {
        return this.sortRackNodes(
            this.rackIncludedNodes,
            this.rackIncludedNodeSortDirection
        );
    }

    public get pagedRackIncludedNodes(): any[] {
        const pageSize = this.normalizeRackPageSize(this.rackIncludedNodePageSize);
        const start = (this.rackIncludedNodePage - 1) * pageSize;
        return this.filteredRackIncludedNodes.slice(
            start,
            start + pageSize
        );
    }

    public get rackIncludedNodeTotalPages(): number {
        return Math.max(
            1,
            Math.ceil(
                this.filteredRackIncludedNodes.length
                    / this.normalizeRackPageSize(this.rackIncludedNodePageSize)
            )
        );
    }

    public get rackIncludedNodePageStart(): number {
        if (this.filteredRackIncludedNodes.length === 0) return 0;
        return (
            (this.rackIncludedNodePage - 1)
            * this.normalizeRackPageSize(this.rackIncludedNodePageSize)
        ) + 1;
    }

    public get rackIncludedNodePageEnd(): number {
        return Math.min(
            this.rackIncludedNodePage
                * this.normalizeRackPageSize(this.rackIncludedNodePageSize),
            this.filteredRackIncludedNodes.length
        );
    }

    public get rackAllAvailableNodesSelected(): boolean {
        if (this.rackNodeSourceTab === 'chassis') {
            const chassisIds = this.rackActiveAvailableChassisIds();
            return chassisIds.length > 0 && chassisIds.every(
                (chassisId: number) => this.rackAvailableChassisSelection.includes(chassisId),
            );
        }
        const nodeIds = this.rackActiveAvailableNodeIds();
        return nodeIds.length > 0 && nodeIds.every(
            (nodeId: number) => this.rackAvailableNodeSelection.includes(nodeId),
        );
    }

    public get rackAllIncludedNodesSelected(): boolean {
        return this.pagedRackIncludedNodes.length > 0 && this.pagedRackIncludedNodes.every(
            (node: any) => this.rackIncludedNodeSelection.includes(Number(node.id || node.node_id)),
        );
    }

    public get rackAllIncludedChassisSelected(): boolean {
        return this.sortedRackIncludedChassis.length > 0 && this.sortedRackIncludedChassis.every(
            (chassis: any) => this.rackIncludedChassisSelection.includes(
                Number(chassis?.id || chassis?.chassis_id || 0),
            ),
        );
    }

    public get rackNodeTotalPages(): number {
        return Math.max(
            1,
            Math.ceil(
                this.rackAvailableSourceCount
                    / this.normalizeRackPageSize(this.rackNodePageSize)
            ),
        );
    }

    public get rackNodePageStart(): number {
        if (this.rackAvailableSourceCount === 0) return 0;
        return (
            (this.rackNodePage - 1)
            * this.normalizeRackPageSize(this.rackNodePageSize)
        ) + 1;
    }

    public get rackNodePageEnd(): number {
        return Math.min(
            this.rackNodePage * this.normalizeRackPageSize(this.rackNodePageSize),
            this.rackAvailableSourceCount,
        );
    }

    private clampRackNodePage() {
        this.rackNodePage = Math.max(
            1,
            Math.min(this.rackNodePage, this.rackNodeTotalPages),
        );
    }

    private clampRackIncludedNodePage() {
        this.rackIncludedNodePage = Math.max(
            1,
            Math.min(this.rackIncludedNodePage, this.rackIncludedNodeTotalPages),
        );
    }

    private initializeRackIncludedNodes(resources: any[] = this.rackPlacements) {
        this.rackIncludedNodeIds = resources
            .filter((placement: any) => placement?.placement_type === 'node')
            .sort((left: any, right: any) => (
                Number(left?.unit_order || 0) - Number(right?.unit_order || 0)
            ))
            .map((placement: any) => Number(placement?.node_id || 0))
            .filter((nodeId: number) => nodeId > 0);
        this.rackIncludedChassisIds = resources
            .filter((placement: any) => placement?.placement_type === 'chassis')
            .sort((left: any, right: any) => (
                Number(left?.unit_order || 0) - Number(right?.unit_order || 0)
            ))
            .map((placement: any) => Number(placement?.chassis_id || 0))
            .filter((chassisId: number) => chassisId > 0);
        this.rackIncludedDevices = resources
            .filter((placement: any) => placement?.placement_type === 'device')
            .map((placement: any) => ({ ...placement }));
        this.rackAvailableNodeSelection = [];
        this.rackAvailableChassisSelection = [];
        this.rackIncludedNodeSelection = [];
        this.rackIncludedChassisSelection = [];
        this.rackNodeSourceTab = 'nodes';
        this.rackNodeSearchText = '';
        this.rackPlacementSearchText = '';
        this.rackPlacementTypeFilter = 'all';
        this.rackPlacementUnitFilter = 'all';
        this.rackPlacementStatusFilter = 'all';
        this.rackPlacementSummarySort = 'unit-desc';
        this.rackPlacementFiltersOpen = false;
        this.rackAutoPlacementPolicy = 'top';
        this.rackNodePage = 1;
        this.rackIncludedNodePage = 1;
    }

    public rackAvailableNodeChecked(node: any): boolean {
        return this.rackAvailableNodeSelection.includes(Number(node?.id || 0));
    }

    public rackIncludedNodeChecked(node: any): boolean {
        return this.rackIncludedNodeSelection.includes(
            Number(node?.id || node?.node_id || 0),
        );
    }

    public rackAvailableChassisChecked(chassis: any): boolean {
        return this.rackAvailableChassisSelection.includes(
            Number(chassis?.id || chassis?.chassis_id || 0),
        );
    }

    public rackIncludedChassisChecked(chassis: any): boolean {
        return this.rackIncludedChassisSelection.includes(
            Number(chassis?.id || chassis?.chassis_id || 0),
        );
    }

    public async toggleRackAvailableNode(node: any) {
        const nodeId = Number(node?.id || 0);
        if (nodeId <= 0) return;
        this.rackAvailableNodeSelection = this.rackAvailableNodeSelection.includes(nodeId)
            ? this.rackAvailableNodeSelection.filter((item: number) => item !== nodeId)
            : [...this.rackAvailableNodeSelection, nodeId];
        await this.service.render();
    }

    public async toggleRackIncludedNode(node: any) {
        const nodeId = Number(node?.id || node?.node_id || 0);
        if (nodeId <= 0) return;
        this.rackIncludedNodeSelection = this.rackIncludedNodeSelection.includes(nodeId)
            ? this.rackIncludedNodeSelection.filter((item: number) => item !== nodeId)
            : [...this.rackIncludedNodeSelection, nodeId];
        await this.service.render();
    }

    public async toggleRackAvailableChassis(chassis: any) {
        const chassisId = Number(chassis?.id || chassis?.chassis_id || 0);
        if (chassisId <= 0) return;
        this.rackAvailableChassisSelection = this.rackAvailableChassisSelection.includes(chassisId)
            ? this.rackAvailableChassisSelection.filter((item: number) => item !== chassisId)
            : [...this.rackAvailableChassisSelection, chassisId];
        await this.service.render();
    }

    public async toggleRackIncludedChassis(chassis: any) {
        const chassisId = Number(chassis?.id || chassis?.chassis_id || 0);
        if (chassisId <= 0) return;
        this.rackIncludedChassisSelection = this.rackIncludedChassisSelection.includes(chassisId)
            ? this.rackIncludedChassisSelection.filter((item: number) => item !== chassisId)
            : [...this.rackIncludedChassisSelection, chassisId];
        await this.service.render();
    }

    public async toggleAllRackAvailableNodes() {
        if (this.rackNodeSourceTab === 'chassis') {
            const ids = this.rackActiveAvailableChassisIds();
            const idSet = new Set(ids);
            this.rackAvailableChassisSelection = this.rackAllAvailableNodesSelected
                ? this.rackAvailableChassisSelection.filter(
                    (chassisId: number) => !idSet.has(chassisId),
                )
                : Array.from(new Set([...this.rackAvailableChassisSelection, ...ids]));
        } else {
            const ids = this.rackActiveAvailableNodeIds();
            const idSet = new Set(ids);
            this.rackAvailableNodeSelection = this.rackAllAvailableNodesSelected
                ? this.rackAvailableNodeSelection.filter(
                    (nodeId: number) => !idSet.has(nodeId),
                )
                : Array.from(new Set([...this.rackAvailableNodeSelection, ...ids]));
        }
        await this.service.render();
    }

    public async toggleAllRackIncludedNodes() {
        const ids = this.pagedRackIncludedNodes.map(
            (node: any) => Number(node?.id || node?.node_id || 0),
        );
        const idSet = new Set(ids);
        this.rackIncludedNodeSelection = this.rackAllIncludedNodesSelected
            ? this.rackIncludedNodeSelection.filter((nodeId: number) => !idSet.has(nodeId))
            : Array.from(new Set([...this.rackIncludedNodeSelection, ...ids]));
        await this.service.render();
    }

    public async toggleAllRackIncludedChassis() {
        const ids = this.sortedRackIncludedChassis.map(
            (chassis: any) => Number(chassis?.id || chassis?.chassis_id || 0),
        );
        const idSet = new Set(ids);
        this.rackIncludedChassisSelection = this.rackAllIncludedChassisSelected
            ? this.rackIncludedChassisSelection.filter(
                (chassisId: number) => !idSet.has(chassisId),
            )
            : Array.from(new Set([...this.rackIncludedChassisSelection, ...ids]));
        await this.service.render();
    }

    public async includeSelectedRackNodes() {
        if (this.rackNodeSourceTab === 'network') return;
        if (this.rackNodeSourceTab === 'chassis') {
            const availableIds = new Set(
                this.rackAvailableChassis.map((chassis: any) => Number(chassis?.id || 0)),
            );
            const selectedIds = this.rackAvailableChassisSelection.filter(
                (chassisId: number) => availableIds.has(Number(chassisId)),
            );
            if (selectedIds.length === 0) return;
            this.rackIncludedChassisIds = Array.from(new Set([
                ...this.rackIncludedChassisIds,
                ...selectedIds,
            ]));
        } else {
            const availableIds = new Set(
                this.rackAvailableNodes.map((node: any) => Number(node?.id || 0)),
            );
            const selectedIds = this.rackAvailableNodeSelection.filter(
                (nodeId: number) => availableIds.has(Number(nodeId)),
            );
            if (selectedIds.length === 0) return;
            this.rackIncludedNodeIds = Array.from(new Set([
                ...this.rackIncludedNodeIds,
                ...selectedIds,
            ]));
        }
        this.rackAvailableNodeSelection = [];
        this.rackAvailableChassisSelection = [];
        this.rackIncludedNodeSelection = [];
        this.rackIncludedChassisSelection = [];
        this.clampRackNodePage();
        this.clampRackIncludedNodePage();
        this.rackWizardError = '';
        await this.service.render();
    }

    public async excludeSelectedRackNodes() {
        const removedNodeIds = new Set(this.rackIncludedNodeSelection.map(Number));
        const removedChassisIds = new Set(this.rackIncludedChassisSelection.map(Number));
        if (removedNodeIds.size === 0 && removedChassisIds.size === 0) return;
        this.rackIncludedNodeIds = this.rackIncludedNodeIds.filter(
            (nodeId: number) => !removedNodeIds.has(Number(nodeId)),
        );
        this.rackIncludedChassisIds = this.rackIncludedChassisIds.filter(
            (chassisId: number) => !removedChassisIds.has(Number(chassisId)),
        );
        this.rackPlacements = this.rackPlacements.filter((placement: any) => (
            placement?.placement_type === 'device'
            || (
                placement?.placement_type === 'node'
                && !removedNodeIds.has(Number(placement?.node_id || 0))
            )
            || (
                placement?.placement_type === 'chassis'
                && !removedChassisIds.has(Number(placement?.chassis_id || 0))
            )
        ));
        this.rackAvailableNodeSelection = [];
        this.rackAvailableChassisSelection = [];
        this.rackIncludedNodeSelection = [];
        this.rackIncludedChassisSelection = [];
        this.clampRackNodePage();
        this.clampRackIncludedNodePage();
        this.rackWizardError = '';
        await this.service.render();
    }

    public async onRackNodeSearchChange() {
        this.rackNodePage = 1;
        await this.service.render();
    }

    public async changeRackNodePageSize() {
        this.rackNodePageSize = this.normalizeRackPageSize(this.rackNodePageSize);
        this.rackNodePage = 1;
        await this.service.render();
    }

    public async changeRackNodeSortDirection(direction: string) {
        this.rackNodeSortDirection = direction === 'desc' ? 'desc' : 'asc';
        this.rackNodePage = 1;
        await this.service.render();
    }

    public async switchRackNodeSourceTab(tab: string) {
        const nextTab = ['nodes', 'chassis', 'network'].includes(tab) ? tab : 'nodes';
        if (this.rackNodeSourceTab === nextTab) return;
        this.rackNodeSourceTab = nextTab;
        this.rackNodeSearchText = '';
        this.rackAvailableNodeSelection = [];
        this.rackAvailableChassisSelection = [];
        this.rackNodePage = 1;
        await this.service.render();
    }

    public async onRackIncludedNodeSearchChange() {
        this.rackIncludedNodePage = 1;
        await this.service.render();
    }

    public async changeRackIncludedNodePageSize() {
        this.rackIncludedNodePageSize = this.normalizeRackPageSize(
            this.rackIncludedNodePageSize
        );
        this.rackIncludedNodePage = 1;
        await this.service.render();
    }

    public async changeRackIncludedNodeSortDirection(direction: string) {
        this.rackIncludedNodeSortDirection = direction === 'desc' ? 'desc' : 'asc';
        this.rackIncludedNodePage = 1;
        await this.service.render();
    }

    public async changeRackNodePage(page: number) {
        this.rackNodePage = Math.max(
            1,
            Math.min(Number(page || 1), this.rackNodeTotalPages)
        );
        await this.service.render();
    }

    public async changeRackIncludedNodePage(page: number) {
        this.rackIncludedNodePage = Math.max(
            1,
            Math.min(Number(page || 1), this.rackIncludedNodeTotalPages)
        );
        await this.service.render();
    }

    public get rackWizardUnits(): number[] {
        const capacity = this.rackCapacity();
        return Array.from({ length: capacity }, (_, index) => capacity - index);
    }

    public get rackWizardHeight(): number {
        return this.rackCapacity() * 16;
    }

    public get rackPlacementLayout(): any[] {
        return this.layoutRackPlacements(this.rackPlacements);
    }

    public get rackPlacementResources(): any[] {
        const chassis = this.rackIncludedChassis.map((resource: any) => ({
            ...resource,
            placement_type: 'chassis',
            chassis_id: Number(resource?.chassis_id || resource?.id || 0),
        }));
        const nodes = this.rackIncludedNodes.map((resource: any) => ({
            ...resource,
            placement_type: 'node',
            node_id: Number(resource?.node_id || resource?.id || 0),
        }));
        const devices = this.rackIncludedDevices.map((resource: any) => ({
            ...resource,
            placement_type: 'device',
        }));
        return [...chassis, ...nodes, ...devices];
    }

    private rackPlacementForResource(resource: any): any | null {
        const key = this.rackPlacementIdentity(resource);
        return this.rackPlacements.find(
            (placement: any) => this.rackPlacementIdentity(placement) === key,
        ) || null;
    }

    private rackSaveResources(): any[] {
        return this.rackPlacementResources.map((resource: any) => {
            const placement = this.rackPlacementForResource(resource);
            return {
                ...resource,
                ...(placement || {}),
                unit_order: placement
                    ? Number(placement?.unit_order || 0)
                    : 0,
                unit_size: Math.max(
                    1,
                    Number(placement?.unit_size || resource?.unit_size || 1),
                ),
            };
        });
    }

    public rackResourceIsPlaced(resource: any): boolean {
        return Boolean(this.rackPlacementForResource(resource));
    }

    public rackResourceUnitSize(resource: any): number {
        const placement = this.rackPlacementForResource(resource);
        return Math.max(1, Number(placement?.unit_size || resource?.unit_size || 1));
    }

    private rackResourceMatchesStepThreeFilters(resource: any): boolean {
        const type = resource?.placement_type === 'device'
            ? 'device'
            : (resource?.placement_type === 'chassis' ? 'chassis' : 'node');
        if (this.rackPlacementTypeFilter !== 'all' && this.rackPlacementTypeFilter !== type) {
            return false;
        }

        const unitSize = this.rackResourceUnitSize(resource);
        if (this.rackPlacementUnitFilter === '1' && unitSize !== 1) return false;
        if (this.rackPlacementUnitFilter === '2' && unitSize !== 2) return false;
        if (this.rackPlacementUnitFilter === '3-4' && (unitSize < 3 || unitSize > 4)) return false;
        if (this.rackPlacementUnitFilter === '5-plus' && unitSize < 5) return false;

        const placed = this.rackResourceIsPlaced(resource);
        if (this.rackPlacementStatusFilter === 'placed' && !placed) return false;
        if (this.rackPlacementStatusFilter === 'unplaced' && placed) return false;

        const term = this.rackPlacementSearchText.trim().toLowerCase();
        if (!term) return true;
        const values = [
            resource?.name,
            resource?.model,
            resource?.serial,
            resource?.bmc_ip,
            resource?.ip_address,
            resource?.group_name,
            resource?.cluster_name,
            resource?.device_type,
            resource?.notes,
            ...(resource?.nodes || []).map((node: any) => node?.name),
        ];
        return values.some(
            (value: any) => String(value || '').toLowerCase().includes(term),
        );
    }

    public get rackFilteredPlacementChassis(): any[] {
        return this.rackPlacementResources.filter((resource: any) => (
            resource?.placement_type === 'chassis'
            && this.rackResourceMatchesStepThreeFilters(resource)
        ));
    }

    public get rackFilteredPlacementNodes(): any[] {
        return this.rackPlacementResources.filter((resource: any) => (
            resource?.placement_type === 'node'
            && this.rackResourceMatchesStepThreeFilters(resource)
        ));
    }

    public get rackFilteredPlacementDevices(): any[] {
        return this.rackPlacementResources.filter((resource: any) => (
            resource?.placement_type === 'device'
            && this.rackResourceMatchesStepThreeFilters(resource)
        ));
    }

    public get rackStepThreeFilteredResourceCount(): number {
        return (
            this.rackFilteredPlacementChassis.length
            + this.rackFilteredPlacementNodes.length
            + this.rackFilteredPlacementDevices.length
        );
    }

    public rackResourceGroupUnits(resources: any[]): number {
        return (resources || []).reduce(
            (total: number, resource: any) => total + this.rackResourceUnitSize(resource),
            0,
        );
    }

    public async onRackPlacementFilterChange() {
        await this.service.render();
    }

    public async toggleRackPlacementFilters() {
        this.rackPlacementFiltersOpen = !this.rackPlacementFiltersOpen;
        await this.service.render();
    }

    public async resetRackPlacementFilters() {
        this.rackPlacementTypeFilter = 'all';
        this.rackPlacementUnitFilter = 'all';
        this.rackPlacementStatusFilter = 'all';
        await this.service.render();
    }

    public get rackUsedUnits(): number {
        return this.rackPlacementLayout.reduce(
            (total: number, placement: any) => (
                total + Math.max(1, Number(placement?.unit_size || 1))
            ),
            0,
        );
    }

    public get rackFreeUnits(): number {
        return Math.max(0, this.rackCapacity() - this.rackUsedUnits);
    }

    public get rackUsageRate(): number {
        const capacity = this.rackCapacity();
        if (capacity <= 0) return 0;
        return Number(((this.rackUsedUnits / capacity) * 100).toFixed(1));
    }

    public get rackFreeRate(): number {
        return Number(Math.max(0, 100 - this.rackUsageRate).toFixed(1));
    }

    public get rackUnplacedResources(): any[] {
        const placedKeys = new Set(
            this.rackPlacements.map(
                (placement: any) => this.rackPlacementIdentity(placement),
            ),
        );
        return this.rackPlacementResources.filter(
            (resource: any) => !placedKeys.has(this.rackPlacementIdentity(resource)),
        );
    }

    public get rackUnplacedResourceCount(): number {
        return this.rackUnplacedResources.length;
    }

    public get rackHasUnitConflict(): boolean {
        const capacity = this.rackCapacity();
        const orders = new Set<number>();
        const occupied = new Set<number>();
        for (const placement of this.rackPlacements) {
            const order = Number(placement?.unit_order || 0);
            if (order < 1 || order > capacity || orders.has(order)) return true;
            orders.add(order);
        }
        for (const placement of this.rackPlacementLayout) {
            const start = Number(placement?.unit_start || 0);
            const end = Number(placement?.unit_end || 0);
            if (start < 1 || end > capacity || end < start) return true;
            for (let unit = start; unit <= end; unit += 1) {
                if (occupied.has(unit)) return true;
                occupied.add(unit);
            }
        }
        return false;
    }

    public get rackHasConsecutiveSpace(): boolean {
        if (this.rackHasUnitConflict) return false;
        const capacity = this.rackCapacity();
        const occupied = new Set<number>();
        for (const placement of this.rackPlacementLayout) {
            const start = Math.max(1, Number(placement?.unit_start || 0));
            const end = Math.min(capacity, Number(placement?.unit_end || 0));
            for (let unit = start; unit <= end; unit += 1) occupied.add(unit);
        }

        const spans: number[] = [];
        let current = 0;
        for (let unit = 1; unit <= capacity; unit += 1) {
            if (occupied.has(unit)) {
                if (current > 0) spans.push(current);
                current = 0;
            } else {
                current += 1;
            }
        }
        if (current > 0) spans.push(current);

        const required = this.rackUnplacedResources
            .map((resource: any) => this.rackResourceUnitSize(resource))
            .sort((left: number, right: number) => right - left);
        const available = spans.sort((left: number, right: number) => right - left);
        for (const size of required) {
            const index = available.findIndex((span: number) => span >= size);
            if (index < 0) return false;
            available[index] -= size;
            available.sort((left: number, right: number) => right - left);
        }
        return true;
    }

    public get rackValidationReady(): boolean {
        return (
            !this.rackStepOneError
            && !this.rackSelectionError
            && !this.rackPlacementError
        );
    }

    public get rackCreateValidationMessage(): string {
        if (this.rackStepOneError) return this.rackStepOneError;
        if (this.rackSelectionError) return this.rackSelectionError;
        if (this.rackPlacementError) return this.rackPlacementError;
        return '';
    }

    public get sortedRackPlacementSummary(): any[] {
        const rows = this.rackPlacementLayout.slice();
        if (this.rackPlacementSummarySort === 'unit-asc') {
            return rows.sort((left: any, right: any) => (
                Number(left?.unit_start || 0) - Number(right?.unit_start || 0)
            ));
        }
        if (this.rackPlacementSummarySort === 'name') {
            return rows.sort((left: any, right: any) => (
                String(left?.name || '').localeCompare(
                    String(right?.name || ''),
                    undefined,
                    { numeric: true, sensitivity: 'base' },
                )
            ));
        }
        if (this.rackPlacementSummarySort === 'type') {
            return rows.sort((left: any, right: any) => (
                this.rackPlacementTypeLabel(left).localeCompare(
                    this.rackPlacementTypeLabel(right),
                )
                || String(left?.name || '').localeCompare(
                    String(right?.name || ''),
                    undefined,
                    { numeric: true, sensitivity: 'base' },
                )
            ));
        }
        return rows.sort((left: any, right: any) => (
            Number(right?.unit_end || 0) - Number(left?.unit_end || 0)
        ));
    }

    public rackPlacementRangeLabel(placement: any): string {
        const start = Number(placement?.unit_start || 0);
        const end = Number(placement?.unit_end || start);
        if (start <= 0) return '미배치';
        return start === end ? `${end} U` : `${end} ~ ${start} U`;
    }

    public rackPlacementSummaryMeta(placement: any): string {
        if (placement?.placement_type === 'chassis') {
            const chassis = this.rackChassis(Number(placement?.chassis_id || 0)) || placement;
            const slots = Number(chassis?.slot_rows || 0) > 0 && Number(chassis?.slot_columns || 0) > 0
                ? `${chassis.slot_rows}×${chassis.slot_columns}`
                : '';
            return [
                chassis?.model || '모델 미입력',
                chassis?.serial ? `Serial ${chassis.serial}` : 'Serial 미입력',
                slots,
                `${Number(chassis?.node_count || 0)} Nodes`,
            ].filter(Boolean).join(' · ');
        }
        if (placement?.placement_type === 'node') {
            const node = this.rackNode(Number(placement?.node_id || 0)) || placement;
            return [
                node?.bmc_ip ? `BMC ${node.bmc_ip}` : 'BMC IP 미입력',
                node?.group_name || node?.cluster_name || '독립 Node',
            ].filter(Boolean).join(' · ');
        }
        return [
            this.rackPlacementTypeLabel(placement),
            placement?.notes,
        ].filter(Boolean).join(' · ');
    }

    public get rackZoneSummaryLabel(): string {
        const zoneId = Number(this.rackForm?.zone_id || 0);
        if (zoneId <= 0) return '미할당 Zone';
        const zone = this.zones.find(
            (item: any) => Number(item?.id || 0) === zoneId,
        );
        if (!zone) return `Zone ${zoneId}`;
        const location = String(zone?.location || '').trim();
        return location ? `${zone.name}  ›  ${location}` : String(zone?.name || `Zone ${zoneId}`);
    }

    public get rackNumberLabel(): string {
        const rackNumber = Math.max(0, Number(this.rackForm?.rack || 0));
        return rackNumber > 0 ? `R${String(rackNumber).padStart(2, '0')}` : '-';
    }

    public async editRackInformation() {
        this.rackWizardStep = 1;
        this.rackWizardError = '';
        this.clearRackDragState();
        await this.service.render();
    }

    public async onRackPlacementSummarySortChange(value: string) {
        this.rackPlacementSummarySort = ['unit-desc', 'unit-asc', 'name', 'type'].includes(value)
            ? value
            : 'unit-desc';
        await this.service.render();
    }

    public async onRackAutoPlacementPolicyChange(value: string) {
        this.rackAutoPlacementPolicy = [
            'top',
            'bottom',
            'network-top',
            'gpu-bottom',
            'chassis-first',
        ].includes(value) ? value : 'top';
        this.rackWizardError = '';
        await this.service.render();
    }


    public get rackPlacementError(): string {
        const capacity = this.rackCapacity();
        const orders = new Set<number>();
        const deviceNames = new Set<string>();
        for (const placement of this.rackPlacements) {
            const order = Number(placement?.unit_order || 0);
            const size = Number(placement?.unit_size || 0);
            if (placement?.placement_type === 'device') {
                const name = String(placement?.name || '').trim();
                if (!name) return '네트워크 장비 이름을 입력하세요.';
                const normalizedName = name.toLowerCase();
                if (deviceNames.has(normalizedName)) {
                    return '같은 네트워크 장비 이름을 두 번 사용할 수 없습니다.';
                }
                deviceNames.add(normalizedName);
            }
            if (order < 1 || order > capacity) {
                return `장비 배치 순서는 1~${capacity} 사이여야 합니다.`;
            }
            if (size < 1 || size > capacity) {
                return `장비 점유 U는 1~${capacity} 사이여야 합니다.`;
            }
            if (orders.has(order)) return `배치 순서 ${order}가 중복되었습니다.`;
            orders.add(order);
        }
        if (this.rackPlacementLayout.some((placement: any) => placement.unit_end > capacity)) {
            return `장비 배치가 Rack 용량 ${capacity}U를 초과합니다.`;
        }
        return '';
    }

    public get rackDeviceDraftError(): string {
        const name = String(this.rackDeviceDraft?.name || '').trim();
        if (!name) return '네트워크 장비 이름을 입력하세요.';
        const unitSize = Number(this.rackDeviceDraft?.unit_size || 0);
        if (unitSize < 1 || unitSize > this.rackCapacity()) {
            return `점유 U는 1~${this.rackCapacity()} 사이여야 합니다.`;
        }
        const duplicate = this.rackIncludedDevices.some((placement: any) => (
            placement?.placement_type === 'device'
            && String(placement?.name || '').trim().toLowerCase() === name.toLowerCase()
        ));
        return duplicate ? '이미 배치된 네트워크 장비 이름입니다.' : '';
    }

    public get rackAutoNodeUnitSizeError(): string {
        const unitSize = Number(this.rackAutoNodeUnitSize);
        if (!Number.isInteger(unitSize) || unitSize < 1 || unitSize > this.rackCapacity()) {
            return `Node당 점유 U는 1~${this.rackCapacity()} 사이의 정수여야 합니다.`;
        }
        return '';
    }

    public get rackStepOneError(): string {
        if (Number(this.rackForm?.rack || 0) <= 0) return 'Rack 번호를 확인할 수 없습니다.';
        const capacity = Number(this.rackForm?.capacity_u || 0);
        if (capacity < 1 || capacity > 100) return 'Rack 용량은 1~100U 사이여야 합니다.';
        return '';
    }

    public get rackSelectionError(): string {
        if (this.rackIncludedNodes.length !== this.rackIncludedNodeIds.length) {
            return '선택한 Node 정보를 확인할 수 없습니다.';
        }
        if (this.rackIncludedChassis.length !== this.rackIncludedChassisIds.length) {
            return '선택한 Chassis 정보를 확인할 수 없습니다.';
        }
        return '';
    }

    public get rackCreateDisabled(): boolean {
        return (
            this.rackCreating
            || Boolean(this.rackStepOneError)
            || Boolean(this.rackSelectionError)
            || Boolean(this.rackPlacementError)
        );
    }

    private rackCapacity(): number {
        return Math.max(1, Math.min(100, Number(this.rackForm?.capacity_u || 42)));
    }

    private syncRackPlacementsToIncludedNodes(
        nodeUnitSize: number | null = null,
        includeMissing: boolean = true,
    ): string {
        const includedNodeIds = Array.from(new Set(
            this.rackIncludedNodeIds
                .map((nodeId: number) => Number(nodeId))
                .filter((nodeId: number) => nodeId > 0),
        ));
        const includedChassisIds = Array.from(new Set(
            this.rackIncludedChassisIds
                .map((chassisId: number) => Number(chassisId))
                .filter((chassisId: number) => chassisId > 0),
        ));
        const includedNodeSet = new Set(includedNodeIds);
        const includedChassisSet = new Set(includedChassisIds);
        const includedDevices: any[] = Array.from(new Map<string, any>(
            this.rackIncludedDevices.map((device: any) => [
                this.rackPlacementIdentity(device),
                { ...device, placement_type: 'device' },
            ]),
        ).values());
        const includedDeviceSet = new Set(
            includedDevices.map((device: any) => this.rackPlacementIdentity(device)),
        );
        const retained = this.rackPlacements
            .filter((placement: any) => (
                (
                    placement?.placement_type === 'device'
                    && includedDeviceSet.has(this.rackPlacementIdentity(placement))
                )
                || (
                    placement?.placement_type === 'node'
                    && includedNodeSet.has(Number(placement?.node_id || 0))
                )
                || (
                    placement?.placement_type === 'chassis'
                    && includedChassisSet.has(Number(placement?.chassis_id || 0))
                )
            ))
            .map((placement: any) => {
                if (placement?.placement_type === 'device') {
                    const device = includedDevices.find((resource: any) => (
                        this.rackPlacementIdentity(resource)
                        === this.rackPlacementIdentity(placement)
                    ));
                    return {
                        ...placement,
                        ...device,
                        unit_order: Number(placement?.unit_order || 0),
                        unit_size: Math.max(1, Number(device?.unit_size || placement?.unit_size || 1)),
                    };
                }
                if (placement?.placement_type === 'node' && nodeUnitSize !== null) {
                    return { ...placement, unit_size: nodeUnitSize };
                }
                if (placement?.placement_type === 'chassis') {
                    const chassis = this.rackChassis(Number(placement?.chassis_id || 0));
                    return {
                        ...placement,
                        unit_size: Math.max(1, Number(chassis?.unit_size || placement?.unit_size || 1)),
                    };
                }
                return {
                    ...placement,
                    unit_size: Number(placement?.unit_size || 1),
                };
            })
            .sort((left: any, right: any) => (
                Number(left?.unit_order || 0) - Number(right?.unit_order || 0)
            ));
        const existingNodeIds = new Set(
            retained
                .filter((placement: any) => placement?.placement_type === 'node')
                .map((placement: any) => Number(placement?.node_id || 0)),
        );
        const existingChassisIds = new Set(
            retained
                .filter((placement: any) => placement?.placement_type === 'chassis')
                .map((placement: any) => Number(placement?.chassis_id || 0)),
        );
        const existingDeviceKeys = new Set(
            retained
                .filter((placement: any) => placement?.placement_type === 'device')
                .map((placement: any) => this.rackPlacementIdentity(placement)),
        );
        const added: any[] = [];
        for (const nodeId of includeMissing ? includedNodeIds : []) {
            if (existingNodeIds.has(nodeId)) continue;
            const node = this.rackNode(nodeId);
            if (!node) return '선택한 Node 정보를 확인할 수 없습니다.';
            added.push({
                placement_type: 'node',
                node_id: nodeId,
                name: String(node?.name || `Node-${nodeId}`),
                unit_order: 0,
                unit_size: nodeUnitSize !== null
                    ? nodeUnitSize
                    : Math.max(1, Number(node?.unit_size || 1)),
            });
        }
        for (const chassisId of includeMissing ? includedChassisIds : []) {
            if (existingChassisIds.has(chassisId)) continue;
            const chassis = this.rackChassis(chassisId);
            if (!chassis) return '선택한 Chassis 정보를 확인할 수 없습니다.';
            added.push({
                placement_type: 'chassis',
                chassis_id: chassisId,
                name: String(chassis?.name || `Chassis-${chassisId}`),
                model: String(chassis?.model || ''),
                serial: String(chassis?.serial || ''),
                node_count: Number(chassis?.node_count || 0),
                nodes: Array.isArray(chassis?.nodes) ? chassis.nodes : [],
                unit_order: 0,
                unit_size: Math.max(1, Number(chassis?.unit_size || 1)),
            });
        }
        for (const device of includeMissing ? includedDevices : []) {
            if (existingDeviceKeys.has(this.rackPlacementIdentity(device))) continue;
            added.push({
                ...device,
                placement_type: 'device',
                unit_order: 0,
                unit_size: Math.max(1, Number(device?.unit_size || 1)),
            });
        }
        const proposed = [...retained, ...added];
        const totalUnits = proposed.reduce((total: number, placement: any) => (
            total + Math.max(1, Number(placement?.unit_size || 1))
        ), 0);
        if (totalUnits > this.rackCapacity()) {
            return `선택한 자원 점유 U 합계 ${totalUnits}U가 Rack ${this.rackCapacity()}U를 초과합니다.`;
        }
        const usedOrders = new Set<number>();
        const invalidOrder = proposed.some((placement: any) => {
            const order = Number(placement?.unit_order || 0);
            if (order < 1 || order > this.rackCapacity() || usedOrders.has(order)) return true;
            usedOrders.add(order);
            return false;
        });
        const overflowing = !invalidOrder && this.layoutRackPlacements(proposed).some(
            (placement: any) => Number(placement?.unit_end || 0) > this.rackCapacity(),
        );
        this.rackIncludedNodeIds = includedNodeIds;
        this.rackIncludedChassisIds = includedChassisIds;
        this.rackIncludedDevices = includedDevices;
        this.rackPlacements = (added.length > 0 || invalidOrder || overflowing)
            ? proposed.map((placement: any, index: number) => ({
                ...placement,
                unit_order: index + 1,
            }))
            : proposed;
        return this.rackPlacementError;
    }

    public async autoArrangeRackPlacements() {
        const unitSizeError = this.rackAutoNodeUnitSizeError;
        if (unitSizeError) {
            this.rackWizardError = unitSizeError;
            await this.service.render();
            return;
        }
        const nodeUnitSize = Number(this.rackAutoNodeUnitSize);
        const selectionError = this.syncRackPlacementsToIncludedNodes(nodeUnitSize);
        if (selectionError) {
            this.rackWizardError = selectionError;
            await this.service.render();
            return;
        }
        this.rackPlacements = this.arrangeRackPlacementsByPolicy(this.rackPlacements);
        this.clearRackDragState();
        this.rackWizardError = this.rackPlacementError;
        await this.service.render();
    }

    private rackPlacementIsGpuCompute(placement: any): boolean {
        if (placement?.placement_type !== 'node') return false;
        const node = this.rackNode(Number(placement?.node_id || 0)) || placement;
        const searchable = [
            node?.name,
            node?.group_name,
            node?.cluster_name,
            node?.role,
            node?.type,
        ].map((value: any) => String(value || '').toLowerCase()).join(' ');
        return /(gpu|compute|accelerator)/.test(searchable);
    }

    private rackStablePlacementOrder(placements: any[]): any[] {
        return placements.slice().sort((left: any, right: any) => {
            const leftOrder = Number(left?.unit_order || 0);
            const rightOrder = Number(right?.unit_order || 0);
            if (leftOrder > 0 && rightOrder > 0 && leftOrder !== rightOrder) {
                return leftOrder - rightOrder;
            }
            if (leftOrder > 0 && rightOrder <= 0) return -1;
            if (rightOrder > 0 && leftOrder <= 0) return 1;
            return this.rackPlacementIdentity(left).localeCompare(
                this.rackPlacementIdentity(right),
            );
        });
    }

    private rackBottomPositions(placements: any[], start: number = 1): any[] {
        let cursor = start;
        return placements.map((placement: any) => {
            const unitSize = Math.max(1, Number(placement?.unit_size || 1));
            const positioned = {
                placement,
                physical_start: cursor,
            };
            cursor += unitSize;
            return positioned;
        });
    }

    private rackTopPositions(placements: any[], end: number = this.rackCapacity()): any[] {
        let cursor = end;
        return placements.map((placement: any) => {
            const unitSize = Math.max(1, Number(placement?.unit_size || 1));
            const physicalStart = cursor - unitSize + 1;
            cursor = physicalStart - 1;
            return {
                placement,
                physical_start: physicalStart,
            };
        });
    }

    private rackPlacementsFromPhysicalPositions(positioned: any[]): any[] {
        let extraUnits = 0;
        return positioned
            .slice()
            .sort((left: any, right: any) => (
                Number(left?.physical_start || 0) - Number(right?.physical_start || 0)
                || this.rackPlacementIdentity(left?.placement).localeCompare(
                    this.rackPlacementIdentity(right?.placement),
                )
            ))
            .map((item: any) => {
                const placement = item.placement;
                const unitSize = Math.max(1, Number(placement?.unit_size || 1));
                const unitOrder = Number(item?.physical_start || 1) - extraUnits;
                extraUnits += unitSize - 1;
                return {
                    ...placement,
                    unit_order: unitOrder,
                    unit_size: unitSize,
                };
            });
    }

    private arrangeRackPlacementsByPolicy(placements: any[]): any[] {
        const ordered = this.rackStablePlacementOrder(placements);
        let positioned: any[] = [];

        if (this.rackAutoPlacementPolicy === 'bottom') {
            positioned = this.rackBottomPositions(ordered);
        } else if (this.rackAutoPlacementPolicy === 'network-top') {
            const network = ordered.filter(
                (placement: any) => placement?.placement_type === 'device',
            );
            const other = ordered.filter(
                (placement: any) => placement?.placement_type !== 'device',
            );
            positioned = [
                ...this.rackBottomPositions(other),
                ...this.rackTopPositions(network),
            ];
        } else if (this.rackAutoPlacementPolicy === 'gpu-bottom') {
            const gpu = ordered.filter(
                (placement: any) => this.rackPlacementIsGpuCompute(placement),
            );
            const other = ordered.filter(
                (placement: any) => !this.rackPlacementIsGpuCompute(placement),
            );
            positioned = this.rackBottomPositions([...gpu, ...other]);
        } else if (this.rackAutoPlacementPolicy === 'chassis-first') {
            const chassis = ordered.filter(
                (placement: any) => placement?.placement_type === 'chassis',
            );
            const other = ordered.filter(
                (placement: any) => placement?.placement_type !== 'chassis',
            );
            positioned = this.rackTopPositions([...chassis, ...other]);
        } else {
            positioned = this.rackTopPositions(ordered);
        }

        return this.rackPlacementsFromPhysicalPositions(positioned);
    }


    private layoutRackPlacements(placements: any[]): any[] {
        const rows = (placements || [])
            .map((placement: any) => ({
                ...placement,
                unit_order: Number(placement?.unit_order || 0),
                unit_size: Math.max(1, Number(placement?.unit_size || 1)),
            }))
            .sort((left: any, right: any) => (
                left.unit_order - right.unit_order
                || this.rackPlacementIdentity(left).localeCompare(this.rackPlacementIdentity(right))
            ));
        let extraUnits = 0;
        return rows.map((placement: any) => {
            const unitStart = placement.unit_order + extraUnits;
            const unitEnd = unitStart + placement.unit_size - 1;
            extraUnits += placement.unit_size - 1;
            return {
                ...placement,
                unit_start: unitStart,
                unit_end: unitEnd,
            };
        });
    }

    private rackNode(nodeId: number): any {
        return this.rackCandidates.find(
            (node: any) => Number(node.id) === Number(nodeId)
        ) || null;
    }

    private rackChassis(chassisId: number): any {
        return this.rackChassisCandidates.find(
            (chassis: any) => Number(chassis?.id || 0) === Number(chassisId),
        ) || null;
    }

    public rackPlacementIdentity(placement: any): string {
        if (placement?.placement_type === 'device') {
            return `device:${Number(placement?.device_id || 0) || String(placement?.client_key || '')}`;
        }
        if (placement?.placement_type === 'chassis') {
            return `chassis:${Number(placement?.chassis_id || placement?.id || 0)}`;
        }
        return `node:${Number(placement?.node_id || placement?.id || 0)}`;
    }

    public rackPlacementKey(placement: any): string {
        return this.rackPlacementIdentity(placement);
    }

    public trackRackPlacement(_index: number, placement: any): string {
        if (placement?.placement_type === 'device') {
            return `device:${Number(placement?.device_id || 0) || String(placement?.client_key || '')}`;
        }
        if (placement?.placement_type === 'chassis') {
            return `chassis:${Number(placement?.chassis_id || placement?.id || 0)}`;
        }
        return `node:${Number(placement?.node_id || placement?.id || 0)}`;
    }

    public rackPlacementIcon(placement: any): string {
        if (placement?.placement_type === 'chassis') return 'bx bx-cabinet';
        if (placement?.placement_type !== 'device') return 'bx bx-server';
        return placement?.device_type === 'kvm' ? 'bx bx-desktop' : 'bx bx-network-chart';
    }

    public rackPlacementTypeLabel(placement: any): string {
        if (placement?.placement_type === 'chassis') return 'Chassis';
        if (placement?.placement_type !== 'device') return 'Node';
        const type = String(placement?.device_type || 'switch').toLowerCase();
        if (type === 'kvm') return 'KVM';
        if (type === 'patch-panel') return 'Patch Panel';
        return type.charAt(0).toUpperCase() + type.slice(1);
    }

    private availableUnitOrder(
        placementKey: string,
        unitSize: number,
        physicalUnit: number
    ): number | null {
        const capacity = this.rackCapacity();
        const placements = this.rackPlacements.filter(
            (placement: any) => this.rackPlacementIdentity(placement) !== placementKey
        );
        const usedOrders = new Set(
            placements.map((placement: any) => Number(placement.unit_order))
        );
        let bestOrder: number | null = null;
        let bestDistance = Number.MAX_SAFE_INTEGER;

        for (let unitOrder = 1; unitOrder <= capacity; unitOrder++) {
            if (usedOrders.has(unitOrder)) continue;
            const candidateType = placementKey.startsWith('device:')
                ? 'device'
                : (placementKey.startsWith('chassis:') ? 'chassis' : 'node');
            const candidate = {
                placement_type: candidateType,
                node_id: candidateType === 'node' ? Number(placementKey.split(':')[1]) : 0,
                chassis_id: candidateType === 'chassis' ? Number(placementKey.split(':')[1]) : 0,
                client_key: candidateType === 'device' ? placementKey.slice(7) : '',
                unit_order: unitOrder,
                unit_size: unitSize,
            };
            const layout = this.layoutRackPlacements([...placements, candidate]);
            if (layout.some((placement: any) => placement.unit_end > capacity)) continue;
            const candidateLayout = layout.find(
                (placement: any) => this.rackPlacementIdentity(placement) === placementKey
            );
            const distance = Math.abs(
                Number(candidateLayout?.unit_start || unitOrder) - physicalUnit
            );
            if (distance < bestDistance) {
                bestDistance = distance;
                bestOrder = unitOrder;
            }
        }
        return bestOrder;
    }

    public rackNodeLocation(node: any): string {
        const rackId = Number(node?.rack_record_id || 0);
        if (rackId <= 0) return 'Rack 미배치';
        const rackName = String(node?.rack_name || '').trim()
            || (String(node?.rack || '').trim() ? `Rack ${node.rack}` : `Rack #${rackId}`);
        const unit = Number(node?.unit_order || 0);
        return unit > 0
            ? `${rackName} · ${unit}U`
            : `${rackName} · U 미배치`;
    }

    public rackNodeWillMove(node: any): boolean {
        const rackId = Number(node?.rack_record_id || 0);
        return rackId > 0 && rackId !== Number(this.rackEditingId || 0);
    }

    public rackPlacementBottom(placement: any): number {
        return (Math.max(1, Number(placement?.unit_start || 1)) - 1) * 16;
    }

    public rackPlacementHeight(placement: any): number {
        return Math.max(15, Number(placement?.unit_size || 1) * 16 - 1);
    }

    private rackPreviewPhysicalUnit(event: DragEvent): number | null {
        const frame = event.currentTarget as HTMLElement | null;
        if (!frame) return null;
        const rect = frame.getBoundingClientRect();
        const capacity = this.rackCapacity();
        const contentHeight = frame.clientHeight;
        if (contentHeight <= 0 || capacity <= 0) return null;
        const offset = Math.max(
            0,
            Math.min(
                contentHeight - 0.01,
                event.clientY - rect.top - frame.clientTop
            )
        );
        const unitHeight = contentHeight / capacity;
        return Math.max(
            1,
            Math.min(capacity, capacity - Math.floor(offset / unitHeight))
        );
    }

    private rackDraggedPlacement(placementKey: string): any | null {
        const existing = this.rackPlacements.find(
            (placement: any) => this.rackPlacementIdentity(placement) === placementKey
        );
        if (existing) return existing;
        if (placementKey.startsWith('device:')) {
            const device = this.rackIncludedDevices.find(
                (resource: any) => this.rackPlacementIdentity(resource) === placementKey,
            );
            return device ? {
                ...device,
                placement_type: 'device',
                unit_order: 1,
                unit_size: Math.max(1, Number(device?.unit_size || 1)),
            } : null;
        }
        if (placementKey.startsWith('chassis:')) {
            const chassisId = Number(placementKey.split(':')[1]);
            const chassis = this.rackChassis(chassisId);
            if (!chassis) return null;
            return {
                placement_type: 'chassis',
                chassis_id: chassisId,
                name: String(chassis?.name || `Chassis-${chassisId}`),
                model: String(chassis?.model || ''),
                serial: String(chassis?.serial || ''),
                node_count: Number(chassis?.node_count || 0),
                nodes: Array.isArray(chassis?.nodes) ? chassis.nodes : [],
                unit_order: 1,
                unit_size: Math.max(1, Number(chassis?.unit_size || 1)),
            };
        }
        if (!placementKey.startsWith('node:')) return null;
        const nodeId = Number(placementKey.split(':')[1]);
        const node = this.rackNode(nodeId);
        if (!node) return null;
        return {
            placement_type: 'node',
            node_id: nodeId,
            name: String(node?.name || `Node-${nodeId}`),
            unit_order: 1,
            unit_size: Math.max(1, Number(node?.unit_size || 1)),
        };
    }

    private rackDragShadowAt(physicalUnit: number): any | null {
        const placementKey = this.draggedRackPlacementKey;
        if (!placementKey) return null;
        const placement = this.rackDraggedPlacement(placementKey);
        if (!placement) return null;
        const unitSize = Math.max(
            1,
            Math.min(this.rackCapacity(), Number(placement?.unit_size || 1))
        );
        const unitOrder = this.availableUnitOrder(
            placementKey,
            unitSize,
            Math.max(1, Math.min(this.rackCapacity(), physicalUnit))
        );
        if (unitOrder === null) return null;
        const candidate = {
            ...placement,
            unit_order: unitOrder,
            unit_size: unitSize,
        };
        const layout = this.layoutRackPlacements([
            ...this.rackPlacements.filter(
                (item: any) => this.rackPlacementIdentity(item) !== placementKey
            ),
            candidate,
        ]);
        return layout.find(
            (item: any) => this.rackPlacementIdentity(item) === placementKey
        ) || null;
    }

    private clearRackDragState() {
        this.draggedRackNodeId = 0;
        this.draggedRackPlacementKey = '';
        this.rackDragShadow = null;
        this.rackDraggedFromPreview = false;
        this.rackRemoveDropActive = false;
    }

    public async onRackFormChange() {
        this.rackWizardError = '';
        await this.service.render();
    }

    public async nextRackWizardStep() {
        if (this.rackWizardStep === 1) {
            this.rackWizardError = this.rackStepOneError;
            if (this.rackWizardError) {
                await this.service.render();
                return;
            }
            this.rackWizardStep = 2;
            this.rackAvailableNodeSelection = [];
            this.rackAvailableChassisSelection = [];
            this.rackIncludedNodeSelection = [];
            this.rackIncludedChassisSelection = [];
            await this.service.render();
            return;
        }
        if (this.rackWizardStep !== 2) return;
        this.rackWizardError = this.rackSelectionError;
        if (!this.rackWizardError) {
            this.rackWizardError = this.syncRackPlacementsToIncludedNodes(null, false);
        }
        if (this.rackWizardError) {
            await this.service.render();
            return;
        }
        this.rackWizardStep = 3;
        this.rackAvailableNodeSelection = [];
        this.rackAvailableChassisSelection = [];
        this.rackIncludedNodeSelection = [];
        this.rackIncludedChassisSelection = [];
        await this.service.render();
    }

    public async previousRackWizardStep() {
        this.rackWizardStep = Math.max(1, this.rackWizardStep - 1);
        this.rackWizardError = '';
        this.clearRackDragState();
        await this.service.render();
    }

    public async onRackNodeDragStart(
        node: any,
        event: DragEvent,
        fromPreview: boolean = false
    ) {
        const nodeId = Number(node?.node_id || node?.id || 0);
        this.draggedRackNodeId = nodeId;
        this.draggedRackPlacementKey = this.rackPlacementIdentity(node);
        this.rackDragShadow = null;
        this.rackDraggedFromPreview = fromPreview;
        this.rackRemoveDropActive = false;
        if (event?.dataTransfer) {
            event.dataTransfer.effectAllowed = 'move';
            event.dataTransfer.setData('text/plain', this.draggedRackPlacementKey);
        }
    }

    public async onRackPlacementDragStart(placement: any, event: DragEvent) {
        await this.onRackNodeDragStart(placement, event, true);
    }

    public async onRackNodeDragEnd() {
        this.clearRackDragState();
        await this.service.render();
    }

    public async onRackPreviewDragOver(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        const removeDropWasActive = this.rackRemoveDropActive;
        this.rackRemoveDropActive = false;
        const physicalUnit = this.rackPreviewPhysicalUnit(event);
        const nextShadow = physicalUnit === null
            ? null
            : this.rackDragShadowAt(physicalUnit);
        const currentKey = this.rackDragShadow
            ? this.rackPlacementIdentity(this.rackDragShadow)
            : '';
        const nextKey = nextShadow ? this.rackPlacementIdentity(nextShadow) : '';
        if (
            currentKey === nextKey
            && Number(this.rackDragShadow?.unit_start || 0)
                === Number(nextShadow?.unit_start || 0)
            && Number(this.rackDragShadow?.unit_end || 0)
                === Number(nextShadow?.unit_end || 0)
            && !removeDropWasActive
        ) return;
        this.rackDragShadow = nextShadow;
        await this.service.render();
    }

    public async onRackPreviewDragLeave(event: DragEvent) {
        const frame = event.currentTarget as HTMLElement | null;
        const relatedTarget = (event as any)?.relatedTarget as Node | null;
        if (frame && relatedTarget && frame.contains(relatedTarget)) return;
        if (!this.rackDragShadow) return;
        this.rackDragShadow = null;
        await this.service.render();
    }

    public async onRackOutsideDragOver(event: DragEvent) {
        if (!this.rackDraggedFromPreview) return;
        event.preventDefault();
        event.stopPropagation();
        if (event.dataTransfer) event.dataTransfer.dropEffect = 'move';
        if (this.rackRemoveDropActive && !this.rackDragShadow) return;
        this.rackRemoveDropActive = true;
        this.rackDragShadow = null;
        await this.service.render();
    }

    public async dropRackPlacementOutside(event: DragEvent) {
        if (!this.rackDraggedFromPreview) return;
        event.preventDefault();
        event.stopPropagation();
        const transferred = String(event?.dataTransfer?.getData('text/plain') || '');
        const placementKey = transferred || this.draggedRackPlacementKey;
        const placement = this.rackPlacements.find(
            (item: any) => this.rackPlacementIdentity(item) === placementKey
        );
        this.clearRackDragState();
        if (!placement) {
            await this.service.render();
            return;
        }
        await this.removeRackPlacement(placement);
    }

    public async dropRackNodeOnPreview(event: DragEvent) {
        event.preventDefault();
        event.stopPropagation();
        const physicalUnit = this.rackPreviewPhysicalUnit(event);
        this.rackDragShadow = null;
        this.rackRemoveDropActive = false;
        if (physicalUnit === null) {
            await this.service.render();
            return;
        }
        await this.dropRackNodeAt(physicalUnit, event);
    }

    public async dropRackNodeAt(physicalUnit: number, event: DragEvent) {
        event.preventDefault();
        const transferred = String(event?.dataTransfer?.getData('text/plain') || '');
        const placementKey = transferred || this.draggedRackPlacementKey;
        const existing = this.rackPlacements.find(
            (placement: any) => this.rackPlacementIdentity(placement) === placementKey,
        );
        if (existing) {
            await this.moveRackPlacement(existing, Number(physicalUnit || 1));
            return;
        }
        if (placementKey.startsWith('device:')) {
            const device = this.rackIncludedDevices.find(
                (resource: any) => this.rackPlacementIdentity(resource) === placementKey,
            );
            if (!device) return;
            await this.placeRackDevice(device, Number(physicalUnit || 1));
            return;
        }
        if (placementKey.startsWith('chassis:')) {
            const chassisId = Number(placementKey.split(':')[1]);
            const chassis = this.rackChassis(chassisId);
            if (!chassis) return;
            await this.placeRackChassis(chassis, Number(physicalUnit || 1));
            return;
        }
        const nodeId = placementKey.startsWith('node:')
            ? Number(placementKey.split(':')[1])
            : this.draggedRackNodeId;
        const node = this.rackNode(nodeId);
        if (!node) return;
        await this.placeRackNode(node, Number(physicalUnit || 1));
    }

    public async addRackNode(node: any) {
        await this.placeRackNode(node, 1);
    }

    public async addRackChassis(chassis: any) {
        await this.placeRackChassis(chassis, 1);
    }

    private async placeRackDevice(device: any, physicalUnit: number) {
        const placementKey = this.rackPlacementIdentity(device);
        if (!placementKey.startsWith('device:')) return;
        if (!this.rackIncludedDevices.some(
            (resource: any) => this.rackPlacementIdentity(resource) === placementKey,
        )) {
            this.rackIncludedDevices = [
                ...this.rackIncludedDevices,
                { ...device, placement_type: 'device' },
            ];
        }
        const existing = this.rackPlacements.find(
            (placement: any) => this.rackPlacementIdentity(placement) === placementKey,
        );
        const unitSize = Math.max(
            1,
            Math.min(this.rackCapacity(), Number(existing?.unit_size || device?.unit_size || 1)),
        );
        const unitOrder = this.availableUnitOrder(
            placementKey,
            unitSize,
            Math.max(1, Math.min(this.rackCapacity(), Number(physicalUnit || 1))),
        );
        if (unitOrder === null) {
            this.rackWizardError = '선택한 네트워크 장비를 배치할 여유 U가 없습니다.';
            await this.service.render();
            return;
        }
        this.rackPlacements = [
            ...this.rackPlacements.filter(
                (placement: any) => this.rackPlacementIdentity(placement) !== placementKey,
            ),
            {
                ...device,
                placement_type: 'device',
                unit_order: unitOrder,
                unit_size: unitSize,
            },
        ].sort((left: any, right: any) => (
            Number(left?.unit_order || 0) - Number(right?.unit_order || 0)
        ));
        this.clearRackDragState();
        this.rackWizardError = '';
        await this.service.render();
    }

    private async placeRackChassis(chassis: any, physicalUnit: number) {
        const chassisId = Number(chassis?.id || chassis?.chassis_id || 0);
        if (chassisId <= 0) return;
        if (!this.rackIncludedChassisIds.includes(chassisId)) {
            this.rackIncludedChassisIds = [...this.rackIncludedChassisIds, chassisId];
        }
        const placementKey = `chassis:${chassisId}`;
        const existing = this.rackPlacements.find(
            (placement: any) => (
                placement?.placement_type === 'chassis'
                && Number(placement?.chassis_id || 0) === chassisId
            ),
        );
        const unitSize = Math.max(
            1,
            Math.min(this.rackCapacity(), Number(existing?.unit_size || chassis?.unit_size || 1)),
        );
        const unitOrder = this.availableUnitOrder(
            placementKey,
            unitSize,
            Math.max(1, Math.min(this.rackCapacity(), Number(physicalUnit || 1))),
        );
        if (unitOrder === null) {
            this.rackWizardError = '선택한 Chassis를 배치할 여유 U가 없습니다.';
            await this.service.render();
            return;
        }
        this.rackPlacements = [
            ...this.rackPlacements.filter(
                (placement: any) => !(
                    placement?.placement_type === 'chassis'
                    && Number(placement?.chassis_id || 0) === chassisId
                ),
            ),
            {
                placement_type: 'chassis',
                chassis_id: chassisId,
                name: String(chassis?.name || `Chassis-${chassisId}`),
                model: String(chassis?.model || ''),
                serial: String(chassis?.serial || ''),
                node_count: Number(chassis?.node_count || 0),
                nodes: Array.isArray(chassis?.nodes) ? chassis.nodes : [],
                unit_order: unitOrder,
                unit_size: unitSize,
            },
        ].sort((left: any, right: any) => (
            Number(left?.unit_order || 0) - Number(right?.unit_order || 0)
        ));
        this.clampRackNodePage();
        this.clearRackDragState();
        this.rackWizardError = '';
        await this.service.render();
    }

    private async placeRackNode(node: any, physicalUnit: number) {
        const nodeId = Number(node?.id || node?.node_id || 0);
        if (nodeId <= 0) return;
        if (!this.rackIncludedNodeIds.includes(nodeId)) {
            this.rackIncludedNodeIds = [...this.rackIncludedNodeIds, nodeId];
        }
        const placementKey = `node:${nodeId}`;
        const existing = this.rackPlacements.find(
            (placement: any) => Number(placement.node_id) === nodeId
        );
        const unitSize = Math.max(
            1,
            Math.min(
                this.rackCapacity(),
                Number(existing?.unit_size || node?.unit_size || 1)
            )
        );
        const unitOrder = this.availableUnitOrder(
            placementKey,
            unitSize,
            Math.max(1, Math.min(this.rackCapacity(), Number(physicalUnit || 1)))
        );
        if (unitOrder === null) {
            this.rackWizardError = '선택한 Node를 배치할 여유 U가 없습니다.';
            await this.service.render();
            return;
        }
        this.rackPlacements = [
            ...this.rackPlacements.filter(
                (placement: any) => Number(placement.node_id) !== nodeId
            ),
            {
                placement_type: 'node',
                node_id: nodeId,
                name: String(node?.name || `Node-${nodeId}`),
                unit_order: unitOrder,
                unit_size: unitSize,
            },
        ].sort((left: any, right: any) => left.unit_order - right.unit_order);
        this.clampRackNodePage();
        this.clearRackDragState();
        this.rackWizardError = '';
        await this.service.render();
    }

    private async moveRackPlacement(placement: any, physicalUnit: number) {
        const key = this.rackPlacementIdentity(placement);
        const unitOrder = this.availableUnitOrder(
            key,
            Math.max(1, Number(placement?.unit_size || 1)),
            Math.max(1, Math.min(this.rackCapacity(), physicalUnit))
        );
        if (unitOrder === null) {
            this.rackWizardError = '선택한 장비를 배치할 여유 U가 없습니다.';
            await this.service.render();
            return;
        }
        placement.unit_order = unitOrder;
        this.clearRackDragState();
        await this.updateRackPlacement();
    }

    public async addManualRackDevice() {
        const draftError = this.rackDeviceDraftError;
        if (draftError) {
            this.rackWizardError = draftError;
            await this.service.render();
            return;
        }
        this.rackDeviceSequence += 1;
        const clientKey = `manual-${Date.now()}-${this.rackDeviceSequence}`;
        const name = String(this.rackDeviceDraft.name || '').trim();
        const deviceType = String(this.rackDeviceDraft.device_type || 'switch');
        const unitSize = Number(this.rackDeviceDraft.unit_size || 1);
        this.rackIncludedDevices = [
            ...this.rackIncludedDevices,
            {
                placement_type: 'device',
                device_id: 0,
                client_key: clientKey,
                name,
                device_type: deviceType,
                notes: '',
                unit_order: 0,
                unit_size: unitSize,
            },
        ];
        this.rackDeviceDraft = this.emptyRackDeviceDraft();
        this.rackWizardError = '';
        await this.service.render();
    }

    public async excludeRackNetworkDevice(device: any, event?: Event) {
        event?.stopPropagation();
        const placementKey = this.rackPlacementIdentity(device);
        this.rackIncludedDevices = this.rackIncludedDevices.filter(
            (resource: any) => this.rackPlacementIdentity(resource) !== placementKey,
        );
        this.rackPlacements = this.rackPlacements.filter(
            (placement: any) => this.rackPlacementIdentity(placement) !== placementKey,
        );
        this.clearRackDragState();
        this.rackWizardError = '';
        await this.service.render();
    }

    public async onRackDeviceDraftChange() {
        this.rackWizardError = '';
        await this.service.render();
    }

    public async onRackAutoNodeUnitSizeChange() {
        this.rackWizardError = '';
        await this.service.render();
    }

    public async updateRackPlacement() {
        this.rackPlacements = this.rackPlacements.slice().sort(
            (left: any, right: any) => (
                Number(left.unit_order || 0) - Number(right.unit_order || 0)
            )
        );
        this.rackWizardError = this.rackPlacementError;
        await this.service.render();
    }

    public async removeRackPlacement(placement: any) {
        const placementKey = this.rackPlacementIdentity(placement);
        this.rackPlacements = this.rackPlacements.filter(
            (item: any) => this.rackPlacementIdentity(item) !== placementKey
        );
        this.clampRackNodePage();
        this.clampRackIncludedNodePage();
        this.rackWizardError = '';
        await this.service.render();
    }

    public async resetRackPlacements() {
        if (this.rackCreating || this.rackPlacements.length === 0) return;
        const confirmed = await this.service.modal.show({
            title: 'Rack 배치 초기화',
            message: '현재 U 배치만 초기화할까요? Step 2에서 선택한 Chassis, Node와 네트워크 장비는 포함 자원으로 유지됩니다.',
            action: '배치 초기화',
            cancel: '취소',
            status: 'warning',
            actionBtn: 'error',
        });
        if (!confirmed) return;
        this.rackPlacements = [];
        this.rackIncludedNodePage = 1;
        this.rackAvailableNodeSelection = [];
        this.rackAvailableChassisSelection = [];
        this.rackIncludedNodeSelection = [];
        this.rackIncludedChassisSelection = [];
        this.rackNodePage = 1;
        this.clearRackDragState();
        this.rackWizardError = '';
        await this.service.render();
    }

    public async saveRack(): Promise<boolean> {
        const selectionError = this.syncRackPlacementsToIncludedNodes(null, false);
        this.rackWizardError = selectionError || this.rackCreateValidationMessage;
        if (this.rackCreateDisabled || this.rackWizardError) {
            await this.service.render();
            return false;
        }

        this.rackCreating = true;
        await this.service.render();
        const saveResources = this.rackSaveResources();
        const payload = {
            ...this.rackForm,
            id: this.rackEditingId,
            zone_id: Number(this.rackForm.zone_id || 0),
            rack: Number(this.rackForm.rack),
            description: String(this.rackForm.description || '').trim(),
            capacity_u: Number(this.rackForm.capacity_u),
            active: Boolean(this.rackForm.active),
            nodes: saveResources
                .filter((placement: any) => placement?.placement_type === 'node')
                .map((placement: any) => ({
                    node_id: Number(placement.node_id),
                    unit_order: Number(placement.unit_order),
                    unit_size: Number(placement.unit_size),
                })),
            chassis: saveResources
                .filter((placement: any) => placement?.placement_type === 'chassis')
                .map((placement: any) => ({
                    chassis_id: Number(placement.chassis_id),
                    unit_order: Number(placement.unit_order),
                    unit_size: Number(placement.unit_size),
                })),
            devices: saveResources
                .filter((placement: any) => placement?.placement_type === 'device')
                .map((placement: any) => ({
                    device_id: Number(placement.device_id || 0),
                    client_key: String(placement.client_key || ''),
                    name: String(placement.name || '').trim(),
                    device_type: String(placement.device_type || 'switch'),
                    notes: String(placement.notes || ''),
                    unit_order: Number(placement.unit_order),
                    unit_size: Number(placement.unit_size),
                })),
        };

        let savedResult: any = null;
        try {
            const { code, data } = await rackEditorApi.call('update_rack', {
                data: JSON.stringify(payload),
            });
            if (code !== 200) {
                this.rackWizardError = data?.message || 'Rack을 수정하지 못했습니다.';
                return false;
            }
            this.captureRackInitialState();
            savedResult = {
                ...data,
                zone_id: Number(payload.zone_id || 0),
            };
        } catch (error) {
            this.rackWizardError = String(error || 'Rack을 수정하지 못했습니다.');
            return false;
        } finally {
            this.rackCreating = false;
            await this.service.render();
        }
        this.saved.emit(savedResult);
        this.closed.emit();
        return true;
    }

    public async closeRackEditor() {
        if (this.rackCreating || this.rackCloseConfirming) return;
        if (this.rackWizardHasUnsavedChanges) {
            this.rackCloseConfirming = true;
            await this.service.render();
            let shouldSave = false;
            try {
                shouldSave = await this.service.modal.show({
                    title: '저장하지 않은 수정사항',
                    message: 'Rack 모달에 저장하지 않은 수정사항이 있습니다. 저장하시겠습니까? 저장하지 않으면 변경사항을 버리고 닫습니다.',
                    action: '저장',
                    cancel: '저장 안 함',
                    status: 'warning',
                    actionBtn: 'success',
                });
            } finally {
                this.rackCloseConfirming = false;
            }
            if (shouldSave) {
                await this.saveRack();
                return;
            }
        }
        this.closed.emit();
    }
}

export default ComponentKieraRackEditorComponent;
